import React from "react";
import AllRoutes from "./Components/Routes/AllRoutes";

const App = () => {
  return (
    <div>
      <AllRoutes />
    </div>
  );
};

export default App;
